<template>
  <div>
    <v-menu
      auto
      offset-y
      open-on-hover
      :content-class="$style.submenuContentWrapper"
      :z-index="100"
    >
      <template #activator="{ on }">
        <div v-on="on">
          <slot />
        </div>
      </template>

      <v-list dense flat tile>
        <v-list-item-group>
          <v-list-item
            v-for="linkTile in linkTiles"
            :key="linkTile.uid"
            :class="$style.listItem"
            :ripple="false"
          >
            <v-list-item-content :class="$style.listContent">
              <LinkTile v-bind="linkTile" render-type="navigationLink" />
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import LinkTile from '@/js/components/Shared/LinkTile.vue'
export default {
  name: 'SubmenuIconWrapper',
  components: { LinkTile },
  props: {
    linkTiles: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style module lang="scss">
.submenuContentWrapper {
  max-height: 100% !important;

  transform: translateX(calc(-50% + 3.75rem));
}

.listContent {
  padding: 0 !important;
}

.listItem {
  overflow: visible !important;

  :global(.v-list-item__content) {
    overflow: visible !important;
  }

  &:last-child {
    .listContent {
      a {
        border-bottom: none !important;
      }
    }
  }
}
</style>
